import React from 'react';
import { NavScrollProvider } from './src/components/context/NavScrollContext';

export function wrapRootElement({ element }) {
  return <NavScrollProvider>{element}</NavScrollProvider>
}
